import { AxiosPromise } from 'axios'
import client from '@/shared/apis/client'
import type { KasanStatusesResponse } from '../types'

// V3 専用. 加算 status 一覧.
// back: GET /api/v3/yakureki/<id>/kasan-statuses/
// candidacy あり (= ○ or ×) の KasanItem のみ返る.
export const getKasanStatuses = (
  yakurekiId: string
): AxiosPromise<KasanStatusesResponse> => {
  return client.get(`/api/v3/yakureki/${yakurekiId}/kasan-statuses/`)
}
